import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import globalPageStyle from '../css/globalPage.module.scss';
import styles from '../css/webhooksPage.module.scss';
import axios from 'axios';
import { EnvPaths } from '../helpers/environment';
import { toast } from 'react-toastify';

const WebhooksPage = () => {
  interface Webhook {
    name: string;
    url: string;
    isActive: boolean;
    webhookId?: string;
  }

  const { user } = useAuth();

  const [loading, setLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  const [webhooks, setWebhooks] = useState<Webhook[]>([]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (user) {
        axios
          .get(`${EnvPaths.SERVER_URL}/admin/get-webhooks`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((response) => {
            setWebhooks(response.data.webhooks as Webhook[]);
          })
          .catch((error) => {
            console.error(error);
          });
        setLoading(false);
      }
    }, 1000);
  }, [user, refetch]);

  const handleRegisterWebhook = async (name: string, url: string) => {
    try {
      toast.loading('Registering webhook...');
      await axios.post(
        `${EnvPaths.SERVER_URL}/admin/register-webhook`,
        {
          webhookName: name,
          webhookUrl: url,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      toast.dismiss();
      toast.success('Webhook registered successfully');
      setRefetch(!refetch);
    } catch (err) {
      toast.dismiss();
      console.error(err);
      toast.error('Failed to register webhook');
    }
  };

  const handleUnregisterWebhook = async (name: string, url: string, webhookId: string) => {
    try {
      toast.loading('Unregistering webhook...');
      await axios.post(
        `${EnvPaths.SERVER_URL}/admin/unregister-webhook`,
        {
          webhookName: name,
          webhookUrl: url,
          webhookId,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      toast.dismiss();
      toast.success('Webhook registered successfully');
      setRefetch(!refetch);
    } catch (err) {
      toast.dismiss();
      console.error(err);
      toast.error('Failed to register webhook');
    }
  };

  return (
    <main className={globalPageStyle.pageContainer}>
      <div className={globalPageStyle.pageContent}>
        {user && user?.role === 'admin' ? (
          loading ? (
            <div className="loader" />
          ) : (
            <>
              <h1>Webhooks</h1>
              <div className={styles.webhooksContainer}>
                <div className={styles.webhookEntry}>
                  <span>Skycop Flight Status</span>
                  <span>{EnvPaths.SERVER_URL}/webhooks/skycop-webhooks/update-flight-status</span>
                  <span>{webhooks.some((webhook) => webhook.name === 'skycop_flight_status') ? 'Active' : 'Inactive'}</span>
                  {!webhooks.some((webhook) => webhook.name === 'skycop_flight_status') ? (
                    <button className="primaryButton" onClick={() => handleRegisterWebhook('skycop_flight_status', `${EnvPaths.SERVER_URL}/webhooks/skycop-webhooks/update-flight-status`)}>
                      Activate
                    </button>
                  ) : (
                    <button
                      className="primaryButton inverse"
                      onClick={() => handleUnregisterWebhook('skycop_flight_status', `${EnvPaths.SERVER_URL}/webhooks/skycop-webhooks/update-flight-status`, webhooks.find((webhook) => webhook.name === 'skycop_flight_status')?.webhookId ?? '')}
                    >
                      Deactivate
                    </button>
                  )}
                </div>
              </div>
            </>
          )
        ) : (
          <h1>You do not have permission to view this page</h1>
        )}
      </div>
    </main>
  );
};

export default WebhooksPage;
